import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("eko_cart") || "[]"); }
    catch { return []; }
  });
  const [pincode, setPincode] = useState(() => localStorage.getItem("eko_pincode") || "");
  const [pincodeInfo, setPincodeInfo] = useState(() => {
    try { return JSON.parse(localStorage.getItem("eko_pincode_info") || "null"); }
    catch { return null; }
  });

  useEffect(() => {
    localStorage.setItem("eko_cart", JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    localStorage.setItem("eko_pincode", pincode || "");
    if (pincodeInfo) localStorage.setItem("eko_pincode_info", JSON.stringify(pincodeInfo));
    else localStorage.removeItem("eko_pincode_info");
  }, [pincode, pincodeInfo]);

  const addItem = (item) => {
    setItems((prev) => {
      const key = `${item.product_id}-${item.weight || "std"}`;
      const idx = prev.findIndex((i) => `${i.product_id}-${i.weight || "std"}` === key);
      if (idx > -1) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + (item.quantity || 1) };
        return copy;
      }
      return [...prev, { ...item, quantity: item.quantity || 1 }];
    });
  };

  const updateQty = (index, qty) => {
    if (qty <= 0) return removeItem(index);
    setItems((prev) => prev.map((it, i) => i === index ? { ...it, quantity: qty } : it));
  };

  const removeItem = (index) => setItems((prev) => prev.filter((_, i) => i !== index));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const deliveryFee = pincodeInfo?.deliverable ? pincodeInfo.delivery_fee : 0;
  const total = subtotal + deliveryFee;
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{
      items, addItem, updateQty, removeItem, clear, subtotal, deliveryFee, total, count,
      pincode, setPincode, pincodeInfo, setPincodeInfo,
    }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
